import { SupportedChainId } from 'constants/chains'

const INFURA_KEY = process.env.REACT_APP_INFURA_KEY
if (typeof INFURA_KEY === 'undefined') {
  throw new Error(`REACT_APP_INFURA_KEY must be a defined environment variable`)
}

/**
 * Fallback JSON-RPC endpoints.
 * These are used if the integrator does not provide an endpoint, or if the endpoint does not work.
 *
 * MetaMask allows switching to any URL, but displays a warning if it is not on the "Safe" list:
 * https://github.com/MetaMask/metamask-mobile/blob/bdb7f37c90e4fc923881a07fca38d4e77c73a579/app/core/RPCMethods/wallet_addEthereumChain.js#L228-L235
 * https://chainid.network/chains.json
 *
 * These "Safe" URLs are listed first, followed by other fallback URLs, which are taken from chainlist.org.
 */
export const FALLBACK_URLS = {
  [SupportedChainId.XDC]: [
    // "Safe" URLs
    'https://rpc.xsp.finance',
    'https://erpc.xinfin.network',
    'https://rpc.ankr.com/xdc/',
    'https://erpc.xdcrpc.com',
    'https://rpc.xdcrpc.com',
    'https://rpc.ankr.com/xdc/78617c36c51be06880f7d5eb629e51cc37905132ca0598606da1ff29925f5d60', //free safari
    'https://rpc.xinfin.network',
    'https://rpc.xdc.org',
  ],
  [SupportedChainId.XDC_TESTNET]: [
    // "Safe" URLs
    'https://erpc.apothem.network',
    'https://rpc.apothem.network',
  ],
}

/**
 * Known JSON-RPC endpoints.
 * These are the URLs used by the interface when there is not another available source of chain data.
 */
export const RPC_URLS = {
  [SupportedChainId.XDC]: [...FALLBACK_URLS[SupportedChainId.XDC]],
  [SupportedChainId.XDC_TESTNET]: ['https://erpc.apothem.network', 'https://rpc.apothem.network'],
}
